import type { ComponentType, SVGProps } from 'react';
import { ReactComponent as MondayLogo } from '../../icons/monday-logo.svg';

export interface IntegrationProviderConfig {
  key: string;
  displayLabel: string;
  logo: ComponentType<SVGProps<SVGSVGElement>>;
  cssPrefix: string;
  panelClassName: string;
  readyClassName: string;
  failedClassName: string;
  messageClassName: string;
  accessibleLabels: {
    disconnect: string;
  };
}

export const MONDAY_PROVIDER: IntegrationProviderConfig = {
  key: 'MONDAY',
  displayLabel: 'Monday.com',
  logo: MondayLogo,
  cssPrefix: 'mnd',
  panelClassName: 'monday-panel',
  readyClassName: 'monday-ready',
  failedClassName: 'monday-failed',
  messageClassName: 'monday-message',
  accessibleLabels: {
    disconnect: 'Disconnect Monday.com',
  },
};

export const providerClass = (
  provider: IntegrationProviderConfig,
  name: string,
): string => `${provider.cssPrefix}-${name}`;

export const providerPath = (
  provider: IntegrationProviderConfig,
  suffix = '',
): string => `/integration-understanding/${provider.key}${suffix}`;
